import React, { memo, Fragment } from 'react';
import reverse from 'lodash/reverse';
import { push } from 'connected-react-router';
import { string } from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useDispatch, useSelector } from 'react-redux';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { formatDate } from '../helpers/dateFormat';
import { getQueryString } from '../Utils/queryString';

function OutcomesChart(props) {
  const dispatch = useDispatch();
  const { patientId = '' } = props;
  const { isPatient = false, from = '', to = '', type = '' } = getQueryString();
  const outcomesData = useSelector(state => state.patientOutcomes.surveyAnalyticsData).map(obj => Object.assign({}, obj, {
    completedAt: formatDate(obj.completedAt, 'MM/DD/YYYY'),
  }));
  return (
    <Fragment>
      {props.showClose && (
        <IconButton style={{ padding: 20 }} color={'secondary'} onClick={() => dispatch(push(isPatient === 'true' ? `/patient/${patientId}` : `/appointment?from=${from}&to=${to}&type=${type}`))}>
          <HighlightOffIcon />
        </IconButton>
      )}
      <div
        style={{
          padding: 30,
          justifyContent: 'center',
          display: 'flex',
        }}
      >
        <BarChart
          width={window.innerWidth / 2}
          height={300}
          data={reverse(outcomesData)}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          <XAxis dataKey="completedAt" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="score" fill="#ffc658" />
        </BarChart>
      </div>
    </Fragment>
  );
}

OutcomesChart.propTypes = {};

export default memo(OutcomesChart);
